var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"masthead"},[_vm._t("masthead-image"),_vm._v(" "),_c('div',{staticClass:"headline"},[_c('h1',[_vm._t("headline")],2),_vm._v(" "),_c('h3',[_vm._t("sub-headline")],2),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._t("content")],2)])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dc0f429","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layoutA/masthead.vue
// module id = null
// module chunks = 